// extracted by mini-css-extract-plugin
export var form = "_ey-0";